import { useEffect, useRef } from 'react';
import { createMap, mapOptionSelector, addSingleLineToMap } from '../lib/mapUtils.js';

/**
 * A small, non-interactive map showing a single activity's route, fitted to
 * bounds. Used by the recent-runs carousel and the recent-runs list page.
 */
export default function RunMiniMap({ activity, className = 'indivRunMap', style }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !activity?.map?.summary_polyline) return undefined;
    const map = createMap(ref.current, mapOptionSelector('recentDisplay'));
    const t = setTimeout(() => {
      map.invalidateSize();
      addSingleLineToMap(map, activity, 20, '#fc5200', 3, 1);
    }, 0);
    return () => {
      clearTimeout(t);
      map.remove();
    };
  }, [activity]);

  return <div ref={ref} className={className} style={style}></div>;
}
